// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"2e1b70db","219":"bda68f14","226":"2c5d0eaa","252":"018aa464","453":"1b6977de","509":"ffefb3f4","605":"d5b38119","990":"fbc45b59","999":"40da102b"}[chunkId] + ".chunk.js";
};